'use strict';

import EaFields from './eaFields.js';
import template from '../../templates/settings/PayrollItem.ejs';
import overtimeTemplate from '../../templates/settings/OvertimePayrollItem.ejs';
import RowEditView from 'commons/views/RowEdit';
import modal from 'helpers/modal';
import Alerts from 'lib/alerts';

module.exports = RowEditView.extend({
    tagName: 'tr',

    events: function() {
        var parentEvents = _.isFunction(RowEditView.prototype.events) ?
            RowEditView.prototype.events() :
            RowEditView.prototype.events;

        return _.extend(_.clone(parentEvents), {
            'change .js-ext.js-ext-eaField': 'updateEaField'
        });
    },

    initialize: function(options) {
        this.options = _.defaults(options || {}, {
            template: template,
            deletable: true,
            unsubmittedPayroll: null,
            showReliefOptions: false
        });
        const applicableEaFields = Object.keys(EaFields)
            .reduce((rs, field) => {
                if (
                    this.options.showReliefOptions ||
                    !['relief', 'zakatRelief'].includes(field)
                ) {
                    return Object.assign(rs, {[field]: EaFields[field]});
                }
                return rs;
            }, {});
        this.options.templateExtra = {
            eaFields: applicableEaFields,
            showType: app.user.isAdmin()
        };

        if (this.model.get('type') === 'overtime') {
            this.options.template = overtimeTemplate;
        }

        if (!this.model.isNew()) {
            this.model.fetchMtdLimit()
                .then(() => RowEditView.prototype.initialize.apply(this, [
                    this.options
                ]));
        } else {
            RowEditView.prototype.initialize.apply(this, [this.options]);
        }

        return this;
    },

    bindHandlers: function() {
        var r = RowEditView.prototype.bindHandlers.apply(this, arguments);
        this.model.on('change:affectsMtd', this.toggleMtdLimit, this);
        this.model.on('change:affectsMtd', this.toggleEaField, this);
        this.model.on('change:mtdLimit', this.toggleEaField, this);
        this.model.on(
            'change:afterWorkingHours', this.checkOvertimeDuplicates, this
        );
        this.model.on(
            'change:nonWorkingDays', this.checkOvertimeDuplicates, this
        );
        this.model.on(
            'change:holidays', this.checkOvertimeDuplicates, this
        );
        return r;
    },

    render: function() {
        var r = RowEditView.prototype.render.apply(this, arguments);
        setTimeout(this.initializeControls.bind(this), 1);
        return r;
    },

    toggleEaField: function(update = true) {
        let disabled = !(
            this.model.get('affectsMtd') &&
            this.model.get('mtdLimit') > 0
        );
        this.$('[name=taxExemptEaField]')
            .prop('disabled', disabled)
            .attr('disabled', disabled);

        if (update) {
            this.updateEaField();
        }
    },

    toggleMtdLimit: function() {
        this.$('[name=mtdLimit]')
            .removeAttr('disabled')
            .prop({disabled: !this.model.get('affectsMtd')})
            .focus().select();

        if (!this.model.get('affectsMtd')) {
            this.$('[name=mtdLimit]').val('0.00').trigger('change');
        }

        return this;
    },

    updateEaField: function() {
        let eaFields = [];
        let eaField = this.$('[name=eaField]').val();
        let taxExemptEaField = this.$('[name=taxExemptEaField]').val();
        let limit;
        let offset;

        limit = offset = this.model.get('mtdLimit') || 0;
        if (eaField) {
            eaFields.push({field: eaField, offset: offset});
        }
        if (taxExemptEaField) {
            eaFields.push({field: taxExemptEaField, limit: limit});
        }
        this.model.set('eaFields', eaFields);
    },

    initializeControls: function() {
        if (!app.user.isSuperAdmin() && !this.model.get('companyId')) {
            this.$('input, select').prop({'disabled': true});
        }

        if (!app.user.isSuperAdmin()) {
            const pcbChecked = this.model.get('affectsMtd') === true;
            this.$('select[name="taxExemptEaField"]')
                .prop('disabled', !pcbChecked || !this.model.get('mtdLimit'));
        } else {
            this.toggleEaField(false);
        }

        // The UI design has a weird placement for the delete button
        this.$('.form-control-with-delete').each(function(i, control) {
            var $control = this.$(control);
            var $value = $control.find('.form-control-value');
            var $input = $control.find('.form-control');

            $value.css({
                display: 'inline-block',
                maxWidth: (
                    $input.width() -
                    $control.find('.btn-delete').outerWidth(true) - 5
                ) + 'px'
            }).text($input.val());

            $value.on('click', function() {
                $control.addClass('focus');
                $input.focus();
            });

            $input.on('keyup', function(ev) {
                var val = this.$(ev.target).val();
                $value.text(val);
            }.bind(this))
            .on('focus', function() {
                $control.addClass('focus');
            })
            .on('blur', function() {
                $control.removeClass('focus');
            });
        }.bind(this));
    },

    checkOvertimeDuplicates: function(model, value, options) {
        //not necessary to check if a flag was disabled
        if (value === false) {
            return;
        }
        let attr = Object.keys(options.changes).pop();
        let collection = this.model.collection;
        let duplicate = collection.find(m => {
            return (
                m.get(attr) === value &&
                m !== model
            );
        });

        if (duplicate) {
            Alerts.show('warning', {
                title: 'Duplicate Overtime Items',
                text: 'The settings you have configured overlap with another ' +
                    'overtime item. This means that any automated function ' +
                    'will utilize the last item you modified.'
            });
        }
    },

    destroyConfirmationMessage: function() {
        if (!this.model.isNew() && this.options.unsubmittedPayroll) {
            return {
                title: 'Your saved payroll will be erased!',
                text:  'You have an unsubmitted payroll saved. If you ' +
                    'continue, the payroll will be reset and all unsubmitted ' +
                    'data will be erased.'
            };
        } else {
            return {};
        }
    },

    destroyModel: function() {
        modal.confirm(_.extend(this.destroyConfirmationMessage(), {
            customClass:        'sweet-alert-error',
            confirmButtonText:  'Yes, Remove Item',
            callback: confirm => {
                var wasNew = this.model.isNew();

                if (!confirm) {
                    return;
                }

                this.model.destroy().then(() => {
                    if (this.model.collection) {
                        this.model.collection.remove(this.model);
                    }

                    if (this.options.unsubmittedPayroll && !wasNew) {
                        return this.options.unsubmittedPayroll.destroy();
                    }

                    return Promise.resolve(true);
                }).then(() => {
                    if (!wasNew) {
                        this.options.unsubmittedPayroll = null;
                    }

                    return Promise.resolve(true);
                }).then(() => this.remove())
                .catch(err => {
                    if (err.response) {
                        Alerts.show('warning', {
                            title: 'Important note!',
                            text: `Please note that this custom item cannot be\
                                deleted as it has already been included in a\
                                payroll.`
                        });
                    } else {
                        Alerts.show('criticalError', err);
                    }
                });
            }
        }));
    }
});



// WEBPACK FOOTER //
// ./app/employer/views/settings/PayrollItem.js